/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionLeagueRead } from './CompetitionLeagueRead';
import {
    CompetitionLeagueReadFromJSON,
    CompetitionLeagueReadFromJSONTyped,
    CompetitionLeagueReadToJSON,
    CompetitionLeagueReadToJSONTyped,
} from './CompetitionLeagueRead';
import type { UserRead } from './UserRead';
import {
    UserReadFromJSON,
    UserReadFromJSONTyped,
    UserReadToJSON,
    UserReadToJSONTyped,
} from './UserRead';
import type { CompetitionSeasonRead } from './CompetitionSeasonRead';
import {
    CompetitionSeasonReadFromJSON,
    CompetitionSeasonReadFromJSONTyped,
    CompetitionSeasonReadToJSON,
    CompetitionSeasonReadToJSONTyped,
} from './CompetitionSeasonRead';

/**
 * 
 * @export
 * @interface CompetitionRead
 */
export interface CompetitionRead {
    /**
     * 
     * @type {string}
     * @memberof CompetitionRead
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof CompetitionRead
     */
    ordinal: number;
    /**
     * 
     * @type {string}
     * @memberof CompetitionRead
     */
    league_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompetitionRead
     */
    season_id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CompetitionRead
     */
    is_public?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompetitionRead
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof CompetitionRead
     */
    created_at: Date;
    /**
     * 
     * @type {string}
     * @memberof CompetitionRead
     */
    organizer_id: string;
    /**
     * 
     * @type {UserRead}
     * @memberof CompetitionRead
     */
    organizer: UserRead;
    /**
     * 
     * @type {number}
     * @memberof CompetitionRead
     */
    problems_count?: number;
    /**
     * 
     * @type {number}
     * @memberof CompetitionRead
     */
    events_count?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CompetitionRead
     */
    has_started_event?: boolean;
    /**
     * 
     * @type {CompetitionLeagueRead}
     * @memberof CompetitionRead
     */
    league?: CompetitionLeagueRead | null;
    /**
     * 
     * @type {CompetitionSeasonRead}
     * @memberof CompetitionRead
     */
    season?: CompetitionSeasonRead | null;
}

/**
 * Check if a given object implements the CompetitionRead interface.
 */
export function instanceOfCompetitionRead(value: object): value is CompetitionRead {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('ordinal' in value) || value['ordinal'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('organizer_id' in value) || value['organizer_id'] === undefined) return false;
    if (!('organizer' in value) || value['organizer'] === undefined) return false;
    return true;
}

export function CompetitionReadFromJSON(json: any): CompetitionRead {
    return CompetitionReadFromJSONTyped(json, false);
}

export function CompetitionReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionRead {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'ordinal': json['ordinal'],
        'league_id': json['league_id'] == null ? undefined : json['league_id'],
        'season_id': json['season_id'] == null ? undefined : json['season_id'],
        'is_public': json['is_public'] == null ? undefined : json['is_public'],
        'id': json['id'],
        'created_at': (new Date(json['created_at'])),
        'organizer_id': json['organizer_id'],
        'organizer': UserReadFromJSON(json['organizer']),
        'problems_count': json['problems_count'] == null ? undefined : json['problems_count'],
        'events_count': json['events_count'] == null ? undefined : json['events_count'],
        'has_started_event': json['has_started_event'] == null ? undefined : json['has_started_event'],
        'league': json['league'] == null ? undefined : CompetitionLeagueReadFromJSON(json['league']),
        'season': json['season'] == null ? undefined : CompetitionSeasonReadFromJSON(json['season']),
    };
}

export function CompetitionReadToJSON(json: any): CompetitionRead {
    return CompetitionReadToJSONTyped(json, false);
}

export function CompetitionReadToJSONTyped(value?: CompetitionRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'ordinal': value['ordinal'],
        'league_id': value['league_id'],
        'season_id': value['season_id'],
        'is_public': value['is_public'],
        'id': value['id'],
        'created_at': ((value['created_at']).toISOString()),
        'organizer_id': value['organizer_id'],
        'organizer': UserReadToJSON(value['organizer']),
        'problems_count': value['problems_count'],
        'events_count': value['events_count'],
        'has_started_event': value['has_started_event'],
        'league': CompetitionLeagueReadToJSON(value['league']),
        'season': CompetitionSeasonReadToJSON(value['season']),
    };
}

